import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { Chart, ChartData, ChartOptions, ChartType, Plugin } from 'chart.js';

@Component({
  selector: 'scip-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements AfterViewInit, OnDestroy {
  @Input() type: ChartType;
  @Input() plugins: Plugin[];
  @Input() width: string;
  @Input() height: string;
  @Input() loading: boolean;
  _data: ChartData<any, any, any>;
  _options: ChartOptions<any>;

  @Input() get data(): ChartData<any, any, any> {
    return this._data;
  }

  set data(val: ChartData<any, any, any>) {
    this._data = val;
    this.reinit();
  }

  @Input() get options(): any {
    return this._options;
  }

  set options(val: any) {
    this._options = val;
    this.reinit();
  }

  private chart: Chart;

  constructor(public el: ElementRef) {}

  ngAfterViewInit(): void {
    this.initChart();
  }

  ngOnDestroy(): void {
    this.chart.destroy();
  }

  private initChart(): void {
    this.chart = new Chart(this.el.nativeElement.children[0].children[0], {
      type: this.type,
      data: this._data,
      options: this._options,
      plugins: this.plugins
    });
  }

  private reinit(): void {
    if (this.chart) {
      this.chart.destroy();
      this.initChart();
      this.resizeChart();
    }
  }

  private resizeChart(): void {
    this.chart.resize(Number.parseInt(this.width), Number.parseInt(this.height));
  }
}
